import Icon from '../assets/wallet.svg';

export function WalletIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={Icon} alt='Wallet' />;
}
